/* import __COLOCATED_TEMPLATE__ from './header-badge.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();